export default __webpack_public_path__ + "static/media/logos-empresas.1ffb665b.png";